<div
  *transloco="let transloco"
  [ngClass]="{
    'mb-5': !this.props.disableMargin
  }"
  class="formly-field flex h-full flex-col gap-2">
  @if (this.props.header) {
    <div class="formly-header" [ngClass]="this.props.headerClass || 'text-2xl'">
      <span>{{ transloco(this.props.header) }}</span>
    </div>
  }

  @if (this.props.label && !this.props.hideLabel) {
    <label
      [for]="id"
      class="formly-field-label"
      [ngClass]="this.props.labelClass || 'text-lg font-bold'">
      <span>{{ transloco(props.label) }}</span>
      @if (this.props.required && !this.props.hideRequiredMarker) {
        <span aria-hidden="true" class="text-red-600">*</span>
      }
    </label>
  }
  <ng-container #fieldComponent></ng-container>

  @if (this.showError) {
    <small class="text-red-600">
      <formly-validation-message
        class="ui-message-text"
        [field]="this.field"></formly-validation-message>
    </small>
  }

  @if (this.props.description) {
    <small
      [innerHTML]="transloco(this.props.description) | libSafeHtml"
      class="formly-field-description prose max-w-full overflow-hidden whitespace-pre-line break-words text-gray-600"></small>
  }

  @if (this.props.footer) {
    <div class="formly-footer" [ngClass]="this.props.footerClass || 'text-2xl'">
      <span>{{ transloco(this.props.footer) }}</span>
    </div>
  }
</div>
